
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers/concealed/[slug]",
      function () {
        return require("private-next-pages/rollers/concealed/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers/concealed/[slug]"])
      });
    }
  